import React, { useEffect, useRef, useState } from "react";
import { fontOptions } from "../utils/helper";
import TeedexFontsComponant from "./TeedexFontsComponant";
import LocalFontsComponants from "./LocalFontsComponants";
import UploadFonts from "./UploadFonts";
import { CustomFontPanel } from "../page/private/PolotnoDesign/CustomFontSection";
const FontComponant = ({
  handlePlayerDetail,
  playerDetail,
  fontSizeToggleState,
  fontSizeToggleFunc,
  componantToggleFunc,
  componatToggleState,
  type,
  teedexFontsList,
  setTeedexFontsList,
  selectedObject,
  store,
}) => {
  const [activeTab, setActiveTab] = useState("teedex");
  const [isFontOpen, setIsFontOpen] = useState(false);
  const fontRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFont, setSelectedFont] = useState("");
  const [originalFont, setOriginalFont] = useState(""); // Store the original font
  const [isFirstHover, setIsFirstHover] = useState(true); // Track if this is the first hover after opening
  const element = store?.selectedElements[0];

  
  // Initialize selectedFont and originalFont when element changes
  useEffect(() => {
    if (element?.fontFamily) {
      setSelectedFont(element.fontFamily);
      setOriginalFont(element.fontFamily);
    }
  }, [element?.fontFamily]);

  // Reset first hover flag when sidebar opens
  useEffect(() => {
    if (isFontOpen) {
      setIsFirstHover(true);
    }
  }, [isFontOpen]);

  const onMouseEnter = (name) => {
    setIsFontOpen(true);
    // Only apply font preview if it's not the first hover after opening
    if (!isFirstHover) {
      element?.set({ fontFamily: name });
      element?.canvas?.requestRenderAll();
    }
  };

  const onMouseLeave = () => {
    setIsFontOpen(true);
    // Only restore font if it's not the first hover after opening
    if (!isFirstHover) {
      element?.set({ fontFamily: originalFont });
      element?.canvas?.requestRenderAll();
    }
  };

  const handleSpanClick = () => {
    // setIsFontOpen(!isFontOpen);
    CustomFontPanel(store);
    // dropdownclickfun(dropdownclickvalue);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleClickOutside = (event) => {
    if (fontRef.current && !fontRef.current.contains(event.target)) {
      setIsFontOpen(false);
    }
  };
  useEffect(() => {
    // if (isFontOpen) {
    //   document.addEventListener("mousedown", handleClickOutside);
    // } else {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // }
    // return () => {
    //   document.removeEventListener("mousedown", handleClickOutside);
    // };
  }, [isFontOpen]);
  return (
    <>
      <div ref={fontRef} className="variation--block__details--handler">
        <div
          onClick={() => handleSpanClick()}
          className={`variation--block__details--handler--nav ${
            isFontOpen ? "activetab" : ""
          }`}
        >
          <h5 style={{color:"black"}}>
            {store.selectedElements[0]?.fontFamily
              ? store.selectedElements[0]?.fontFamily
              : "Font"}
          </h5>
          <h6>{playerDetail?.fontFamily}</h6>
        </div>

        {isFontOpen && (
          <div
            style={{ display: "block" }}
            className="variation--block__details--container font-name"
          >
            <div className="search-block">
              <input
                type="text"
                placeholder="Search Fonts"
                value={searchQuery}
                onChange={handleSearchChange}
              />
              {searchQuery && (
                <span
                  className="clear-icon"
                  onClick={() => {
                    setSearchQuery(""); // Clear the search query
                  }}
                >
                  ✖
                </span>
              )}
            </div>

            <div className="tabs">
              <div className="tab-navs">
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => setActiveTab("teedex")}
                  className={
                    activeTab === "teedex" ? "tab-nav active" : "tab-nav"
                  }
                  data-id="teedex-font"
                >
                  Teedex Fonts
                </span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => setActiveTab("local")}
                  className={
                    activeTab === "local" ? "tab-nav active" : "tab-nav"
                  }
                  data-id="system-font"
                >
                  Your System Fonts
                </span>
              </div>

              {/* <div
                className={
                  activeTab === "teedex" ? "tab-content active" : "tab-content"
                }
              >
                <TeedexFontsComponant
                  fontOptions={fontOptions}
                  onSelect={handlePlayerDetail}
                  selected={playerDetail}
                  type="newcomponant"
                  teedexFontsList={teedexFontsList}
                  setTeedexFontsList={setTeedexFontsList}
                  selectedObject={selectedObject}
                  searchQuery={searchQuery}
                  store={store}
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                  setSelectedFont={setSelectedFont}
                  setOriginalFont={setOriginalFont}
                  setIsFirstHover={setIsFirstHover}
                />
              </div>
              <div
                className={
                  activeTab === "local" ? "tab-content active" : "tab-content"
                }
              >
                <LocalFontsComponants
                  onSelect={handlePlayerDetail}
                  selected={playerDetail}
                  selectedObject={selectedObject}
                  type="newcomponant"
                  searchQuery={searchQuery}
                  store={store}
                  onMouseEnter={onMouseEnter}
                  onMouseLeave={onMouseLeave}
                  setSelectedFont={setSelectedFont}
                  setOriginalFont={setOriginalFont}
                  setIsFirstHover={setIsFirstHover}
                  // onHover={onHover}
                />
              </div> */}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default FontComponant;
